import { register } from "@rill/loader";
import moment from "moment";

register(
  {
    name: "workflows",
    meta: ["no-bust", "workflow"],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const query = {
      limit: false,
      sort: { order: 1 },
    };

    const res = await api("workflow", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "coachMonitoringSettings",
    meta: ["no-bust", "coach-monitoring-settings"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const res = await api(`coach-monitoring-settings/${proxyAthlete}`);
    return res.json();
  }
);

register(
  {
    name: "macroCalculators",
    meta: ["no-bust", "widget", "macro-calculator"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { access }) => {
    const query = {
      limit: false,
      type: "macro-calculator",
      status: "published",
    };
    if (access === "pull") {
      query.pullPermission = true;
    } else {
      query.pushPermission = true;
    }

    if (locals.activeUser.organizationId) {
      const res = await api("widget-organization", { query });
      const data = await res.json();
      const { widgets = [] } = data;
      return widgets;
    } else {
      const res = await api("widget", { query });
      const data = await res.json();
      return data;
    }
  }
);

register(
  {
    name: "videoPlaylistWidgets",
    meta: ["no-bust", "widget", "video-playlist"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { access }) => {
    const query = {
      limit: false,
      type: "video-playlist",
      status: "published",
    };
    if (access === "pull") {
      query.pullPermission = true;
    } else {
      query.pushPermission = true;
    }

    if (locals.activeUser.organizationId) {
      const res = await api("widget-organization", { query });
      const data = await res.json();
      const { widgets = [] } = data;
      return widgets;
    } else {
      const res = await api("widget", { query });
      const data = await res.json();
      return data;
    }
  }
);

register(
  {
    name: "guidesWidgets",
    meta: ["no-bust", "widget", "file-documents"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { access }) => {
    const query = {
      limit: false,
      type: "file-documents",
      status: "published",
    };
    if (access === "pull") {
      query.pullPermission = true;
    } else {
      query.pushPermission = true;
    }

    if (locals.activeUser.organizationId) {
      const res = await api("widget-organization", { query });
      const data = await res.json();
      const { widgets = [] } = data;
      return widgets;
    } else {
      const res = await api("widget", { query });
      const data = await res.json();
      return data;
    }
  }
);

register(
  {
    name: "mealPlanWidgets",
    meta: ["no-bust", "widget", "meal-plan-library"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { access }) => {
    const query = {
      limit: false,
      type: "meal-plan-library",
      status: "published",
    };
    if (access === "pull") {
      query.pullPermission = true;
    } else {
      query.pushPermission = true;
    }

    if (locals.activeUser.organizationId) {
      const res = await api("widget-organization", { query });
      const data = await res.json();
      const { widgets = [] } = data;
      return widgets;
    } else {
      const res = await api("widget", { query });
      const data = await res.json();
      return data;
    }
  }
);

register(
  {
    name: "accountabilityWidgets",
    meta: ["no-bust", "widget", "daily-accountability-template"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { access }) => {
    const query = {
      limit: false,
      type: "daily-accountability-template",
      status: "published",
    };
    if (access === "pull") {
      query.pullPermission = true;
    } else {
      query.pushPermission = true;
    }

    if (locals.activeUser.organizationId) {
      const res = await api("widget-organization", { query });
      const data = await res.json();
      const { widgets = [] } = data;
      return widgets;
    } else {
      const res = await api("widget", { query });
      const data = await res.json();
      return data;
    }
  }
);

register(
  {
    name: "onboardingQuestionnaire",
    meta: ["no-bust", "daily-stats"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { proxyAthlete }) => {
    const billingRes = await api("coach-billing-start-date", {
      query: {
        proxyAthlete,
        organizationOwnerCoach: locals.organizationOwner?._id,
      },
    });
    const { startDate } = await billingRes.json();

    const targetQuery = {
      query: {
        limit: false,
        proxyAthlete,
        onboarding: { $exists: true },
      },
    };

    if (startDate) {
      targetQuery.query.utcDate = {
        $gte: Number.parseInt(
          moment.utc(startDate).subtract(1, "day").format("YYYYMMDD"),
          10
        ),
      };
    }

    const res = await api("daily-stats", targetQuery);
    const jsonRes = await res.json();

    return jsonRes.length > 0 ? jsonRes[0] : null;
  }
);
